import { createFileRoute } from "@tanstack/react-router";

import { isWeb } from "@/app/platform";
import { BannersPlacement } from "@/components/BannersPlacement/BannersPlacement";
import { Footer } from "@/components/Footer/Footer";
import { PatternBackground } from "@/components/Icons";
import { SearchNavigationButtons } from "@/components/SearchNavigationButtons/SearchNavigationButtons";
import { LogOutButton } from "@/components/Web/LogOutButton";
import { MainSearchWhatsAppBanner } from "@/components/WhatsApp/WhatsAppBanners";
import { TripCarousel } from "@/features/trips/components/TripCarousel";
import { BannersPlacementSlug } from "@/types/enums";
import { isProduction } from "@/utils/constants";
import { Feature, isFeatureEnabled } from "@/utils/featureFlags";

export const Route = createFileRoute("/_authenticated/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <main className="main">
      <div className="relative flex w-full items-center justify-center overflow-clip bg-surface-accent-stronger pt-6 pb-12">
        <PatternBackground aria-hidden className="absolute inset-0" />

        {!isProduction ? (
          <>
            {isWeb ? (
              <div className="absolute start-0.5 top-0.25 text-white">
                <LogOutButton />
              </div>
            ) : null}

            <div className="absolute start-0 top-0 flex w-full justify-center">
              <div className="rounded-b-md bg-surface-accent-strong/75 px-2 py-0.5 text-xs text-white/75 capitalize">
                {import.meta.env.VITE_PUBLIC_ENVIRONMENT}
              </div>
            </div>
          </>
        ) : null}

        <SearchNavigationButtons />
      </div>

      <div className="relative -mt-6 flex flex-col gap-4.5 rounded-t-3xl bg-surface-background pt-6 pb-20">
        <BannersPlacement slug={BannersPlacementSlug.HOMEPAGE_BELOW_SEARCH} />

        {isFeatureEnabled(Feature.TripsFlow) ? <TripCarousel /> : null}

        <div className="px-4">
          <MainSearchWhatsAppBanner />
        </div>
      </div>

      <Footer />
    </main>
  );
}
